import { withTranslation } from 'react-i18next';
import { Typography, Box, Input, FormControl } from '@material-ui/core';
import compose from 'ramda/src/compose';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  'field__input--error': {
    borderColor: theme.palette.error.main,
    borderWidth: '2px',
  },
  voucherCodeField: {
    '&.MuiInputBase-root': {
      '&.Mui-focused': {
        boxShadow: '0 0 10px #9ecaed',
      },
    },
  },
}));

function VoucherCodeField(props) {
  const { form = {}, name, autoFocusRef } = props;
  const { values = {} } = form;
  const classes = useStyles();

  return (
    <Box className={`field field--${name}`} mb={4}>
      <FormControl className={`field__form-control`}>
        <Input
          data-cy="field__input"
          data-testid="voucherCode"
          className={`field__input ${classes.voucherCodeField} ${
            form?.errors?.[name] ? classes['field__input--error'] : ''
          }`}
          disableUnderline
          fullWidth
          name={name}
          onChange={form.handleChange}
          value={values[name] || ''}
          inputRef={(input) => {
            autoFocusRef && (autoFocusRef.current = input);
          }}
        />
      </FormControl>
      {form?.errors?.[name] ? (
        <Box ml={3} mt={2} className={`field__errorBox`}>
          <Typography variant="body2" color="error">
            {form.errors[name]}
          </Typography>
        </Box>
      ) : null}
    </Box>
  );
}

export default compose(withTranslation())(VoucherCodeField);
